export default __webpack_public_path__ + "static/fb_register-49b231e0a4878df82942f3f256b73040.png";